export const TOTAL_ROW_NUMBER = 'Total';

export const dynamicColumnsFieldNameBeginning = 'values';
export const currentValueFieldNameSuffix = '.current';
export const compareValueFieldNameSuffix = '.compare';
export const varianceValueFieldNameSuffix = '.variance';
export const squareBracketsOpening = "['";
export const squareBracketsClosing = "']";
